<template>
  <div :class="`${if_selected} ${clazz} w-100`">
    <div class="md-layout">
      <label for="name">
        <b class="md-layout-item md-caption">{{ tx(model) }}</b></label
      >
      <helpWidget
        style="float: right"
        class="md-layout-item"
        :help="help_key"
      ></helpWidget>
    </div>
    <br />
    <round-slider
    class="m-auto"
      v-model="sliderValue"
      readOnly="true"
      start-angle="0"
      end-angle="+360"
      line-cap="round"
      :radius="width"
      :min="min"
      :max="max"
      :step="step"
      :rangeColor="
        this.type_component == 'output' ? this.outputColor : this.inputColor
      "
      :tooltip-format="sliderTooltipFormatter"
    />
  </div>
</template>

<script>
import RoundSlider from "vue-round-slider";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import httpService from "../services/http-service.js";

export default {
  name: "valve-output-component",
  mixins: [inputComponentMixin, dataComponentMixin],
  components: { RoundSlider },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sliderValue: 0,
      min: 0,
      max: 100,
      step: 0,
      width: 0,
      if_selected: "",
    };
  },
  watch: {
    sliderValue(oldval, val) {
      //update value with sliderValue model in round slider
      if (this.customValues.length > 0) {
        this.value = this.customValues[this.sliderValue];
      } else {
        this.value = this.sliderValue;
      }
    },
  },
  async mounted() {
    Bus.$on("ireal-start", () => {
      this.sliderValue = 0;
    });
    //initialize model value
    if (this.customValues.length > 0) {
      this.sliderValue = this.customValues.indexOf(this.attributes.defaut);
    } else {
      this.sliderValue = parseFloat(this.attributes.defaut).toFixed(2);
    }

    this.update_selected();

    // write attributes for valve ( round-slider ). For values in array , min and max are range of tick
    // example: array [2,10,14,31] have min 0 and max 3
    Bus.$on("selected-changed", () => {
      this.update_selected();
      this.min = this.attributes.min;
      this.max = this.attributes.max;
      this.step = this.attributes.step;
      this.width = this.attributes.width;
    });
  },
  computed: {
    sliderObj() {
      return this.$refs.slider1.instance;
    },
    // read the list of values from xml layout
    customValues() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
    // read if valve has a component parent.
    // this valve is show only if parent component select the dependance value
    id_selected_tab() {
      if (this.attributes.id_selected === undefined) return [];
      else return this.attributes.id_selected.split("|");
    },
  },
  methods: {
    prepare() {},
    sliderTooltipFormatter: function (e) {
      return this.customValues[e.value];
    },
    tickFlux(flux_structure) {
      for (var i in flux_structure.data) {
        this.sliderValue = parseFloat(flux_structure.data[i].number_value);

        if (flux_structure.data[i]["time"] > this.$store.getters.progress) {
          //console.log(flux_structure.data[i]["time"], this.$store.getters.progress);
          break;
        }
      }
    },
    tick() {
      this.value = this.getDataForFlux(this.attributes.name).number_value;

      // Updates the DOM for each flux (rendering)
      Object.keys(this.objectData).forEach((flux_identifier) => {
        let flux_structure = this.getFluxStructure(flux_identifier);
        this.tickFlux(flux_structure);
      }, this);
    },
    componentStartEvent() {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: this.flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };

      this.getTimeData(params);
      // retourne toutes les promesses, lorsqu'elles sont toutes résolues. Sinon, le mounted subira une erreur au niveau du then
    },
  },
};
</script>
